module.exports = __webpack_public_path__ + "img/home-icon.bda72608.png";